import { addEvents } from '../../helpers/dom/addEvents';
import { ancestorBySelector } from "../../helpers/element/findAncestor";

class InputLabel {
	constructor(elem) {
		this.input = elem;
		this.parent = null;

		this.getElements();
		this.setEvents();
		this.checkValues('is-active');
	}

	getElements() {
		this.parent = ancestorBySelector(this.input, '.form__group--vert-label');
	}

	setEvents() {
		addEvents(this.input, ['keydown', 'keyup'], () => {
			this.doKeyEvents(this.input);
		});

		addEvents(this.input, ['focus'], () => {
			this.doFocusEvent();
		});

		addEvents(this.input, ['blur'], () => {
			this.doBlurEvent();
		});
	}

	doKeyEvents() {
		this.checkValues('is-active');
	}

	doFocusEvent() {
		if (this.parent && this.parent !== null) {
			this.parent.classList.add('is-focused');
		}
	}

	doBlurEvent() {
		this.checkValues('is-focused');
	}

	checkValues(className) {
		if (this.parent && this.parent !== null) {
			if (this.inputHasValue()) {
				this.parent.classList.add(className);
			} else {
				this.parent.classList.remove(className);
			}
		}
	}

	inputHasValue() {
		return this.input.value.length > 0 || this.input.value !== this.input.defaultValue;
	}
}

export function gravityFormInputLabels() {
	const inputs = document.querySelectorAll('.form__group--vert-label input');
	const textareas = document.querySelectorAll('.form__group--vert-label textarea');

	const elems = [...inputs, ...textareas];

	if (elems.length > 0) {
		elems.forEach((input) => {
			new InputLabel(input);
		});
	}
};


// Add this at the bottom of the file
if (window.jQuery) {
    jQuery(document).on('gform_post_render', function() {
        gravityFormInputLabels();
    });
}